import { Component, OnInit } from '@angular/core';
import $ from 'jquery';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.css'],
    standalone: false
})
export class NavigationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    $(document).ready(function() {
      var scroll_pos = 0;
      var screen_size = window.screen.width;
      //console.log(screen_size);
      $(document).scroll(function() {
          scroll_pos = $(this).scrollTop();
          if (screen_size <= 680) {
            $('.bg-clear').css('background-color', '#232323');
          } else {
            if (scroll_pos > 50) {
              $('.bg-clear').css('background-color', '#232323');
            } else {
              $('.bg-clear').css('background-color', 'transparent');
            }
          }
      });
    });

    //To hide navbar when you click in an option
    $(document).ready(function () {
      $('.nav-item').on('click', function(){
        (<any>$('.navbar-collapse')).collapse('hide');
      });
    });
  }
}
